import { EOfferType } from 'shared/repositories/hidden-objects/entities/offer_hiding/HideOfferRequestSchema';
import { ECategory } from 'shared/repositories/offers-comparison/entities/offer/OfferDesktopSchema';

import { ELabelColor } from '../types/label';
import { IOffer } from '../types/offer';

export const prepareNotApprovedLayoutLabel = (offer: IOffer) => {
  // в контексте текущей фичи null/undefined === true
  if (
    offer.isLayoutApproved !== false ||
    offer.category !== ECategory.FlatShareSale ||
    offer.offerType !== EOfferType.Flat
  ) {
    return;
  }

  return {
    color: ELabelColor.Yellow,
    text: 'Перепланировка',
  };
};
